import { Controller } from "@hotwired/stimulus"

// Opens a centered video modal using a stable Active Storage redirect URL.
export default class extends Controller {
  static targets = ["modal", "player", "title"]

  open(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    const url = trigger.dataset.videoUrl
    const title = trigger.dataset.videoTitle

    if (!url || !this.hasModalTarget || !this.hasPlayerTarget) return

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = title || ""
    }

    this.playerTarget.src = url
    this.showModal()
  }

  close() {
    this.hideModal()
  }

  showModal() {
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    document.body.classList.add("overflow-hidden")
  }

  hideModal() {
    if (this.hasPlayerTarget) {
      this.playerTarget.pause()
      this.playerTarget.removeAttribute("src")
      this.playerTarget.load()
    }

    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    document.body.classList.remove("overflow-hidden")
  }
}
